import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from '@mui/material';

const UserDeleteConfirmation = ({ user, handleClose, handleDelete }) => {
  const [record, setRecord] = useState({});

  useEffect(() => {
    setRecord(user);
  }, [user]);

  return (
    <Dialog
      open={true}
      onClose={(event, reason) => reason === 'backdropClick' || handleClose()}
      disableEscapeKeyDown
    >
      <DialogTitle>Delete User?</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete the user, {record.username}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            handleDelete(record);

            handleClose(e);
          }}
        >
          OK
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDeleteConfirmation;
